export default __webpack_public_path__ + "static/media/logo-us-wayfair.d640848f.svg";